var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-status"},[_c('div',{staticClass:"publish-status"},[_c('span',{staticClass:"publish-status__indicator",attrs:{"data-state":_vm.postStatus}}),_vm._v("\n            "+_vm._s(_vm.postStatusText)+"\n        ")])])}
var staticRenderFns = []

export { render, staticRenderFns }